/* eslint-disable react/prop-types */
import React, { Fragment, useState, useEffect } from 'react';
import Divider from '@mui/material/Divider';
import Typography from "@mui/material/Typography";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import DisplayAdmissionApplications from './HelperChunks/DisplayAdmissionApplications';
import { Link } from 'react-router-dom';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
} from "@mui/material";
import LoginMenu from '../../../components/LoginMenu/LoginMenu';


function isEmpty(obj) {

    if (obj == null) return true;

    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    if (typeof obj !== "object") return true;

    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}

const ReviewAdmissionApplication = (props) => {
    const [state, setState] = useState({
        open: false,
        isNotUploaded: false,
        uploadMsg: "",
        data: {},
        documentsData: [],
        documentsList: [],
        loadingData: false,
        loadingCheck: false,
        loadingSubmit: false,
        firstMsg: "",
        isFormSubmited: false,
        isLoginMenu: false,
        isReload: false,
        successDialog: false
    });

    const updateState = (updates) => setState(prev => ({ ...prev, ...updates }));

    useEffect(() => {
        getCheck();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getCheck = async () => {
        let documentsData = [];
        let documentsList = [];
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationDocumentsReviewApplicationView`;
        updateState({ loadingCheck: true });

        try {
            const res = await fetch(url, {
                method: "GET",
                headers: new Headers({
                    Authorization: "Bearer " + localStorage.getItem("uclToken")
                })
            });
            if (!res.ok) throw res;

            const json = await res.json();

            if (json.DATA) {
                documentsData = json.DATA || [];

                if (localStorage.getItem("isSubmitted") != 1) {
                    const urlList = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationRequiredDocumentListView`;
                    try {
                        const resList = await fetch(urlList, {
                            method: "GET",
                            headers: new Headers({
                                Authorization: "Bearer " + localStorage.getItem("uclToken")
                            })
                        });
                        if (!resList.ok) throw resList;
                        const jsonList = await resList.json();
                        if (jsonList.DATA) {
                            documentsList = jsonList.DATA || [];
                        }
                    } catch (error) {
                        console.log(error);
                    }

                    let isNotUploaded = false;
                    let uploadMsg = "";
                    let firstMsg = "";

                    let label = "";
                    if (documentsData.length <= 0) {
                        isNotUploaded = true;
                        uploadMsg = '';
                        firstMsg = 'Please scan and upload your supporting documents in Document Upload section';
                    } else {
                        firstMsg = 'Please scan and upload following documents in Document Upload section';

                        const pass = documentsData.find(item => item.documentTypeId === 1);
                        const cnic = documentsData.find(item => item.documentTypeId === 2);
                        const olevel = documentsData.find(item => item.documentTypeId === 9);
                        const alevel = documentsData.find(item => item.documentTypeId === 4);

                        if (isEmpty(pass)) {
                            label = documentsList.find(d => d.ID === 1)?.Label || '';
                            uploadMsg = `${uploadMsg}${uploadMsg ? ',' : ''} ${label}`;
                            isNotUploaded = true;
                        }
                        if (isEmpty(cnic)) {
                            label = documentsList.find(d => d.ID === 2)?.Label || '';
                            uploadMsg = `${uploadMsg}${uploadMsg ? ',' : ''} ${label}`;
                            isNotUploaded = true;
                        }
                        const applicantDegreeId = Number(documentsData[0].degreeId);
                        if (applicantDegreeId === 32) {
                            if (isEmpty(olevel)) {
                                label = documentsList.find(d => d.ID === 9)?.Label || '';
                                uploadMsg = `${uploadMsg}${uploadMsg ? ',' : ''} ${label}`;
                                isNotUploaded = true;
                            }
                        }
                        if ((applicantDegreeId >= 2 && applicantDegreeId <= 9) || applicantDegreeId === 13 || applicantDegreeId === 14) {
                            if (isEmpty(alevel)) {
                                label = documentsList.find(d => d.ID === 4)?.Label || '';
                                uploadMsg = `${uploadMsg}${uploadMsg ? ',' : ''} ${label}`;
                                isNotUploaded = true;
                            }
                        }
                    }

                    updateState({
                        documentsData,
                        isNotUploaded,
                        uploadMsg,
                        firstMsg
                    });
                } else {
                    updateState({ documentsData });
                }
            }
        } catch (error) {
            if (error.status == 401) {
                updateState({
                    isLoginMenu: true,
                    isReload: true
                });
            } else {
                alert('Failed to fetch, Please try again later.');
                console.log(error);
            }
        }
        updateState({ loadingCheck: false });
    };

    const getData = async () => {
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationView`;
        updateState({ loadingData: true });

        try {
            const res = await fetch(url, {
                method: "GET",
                headers: new Headers({
                    Authorization: "Bearer " + localStorage.getItem("uclToken")
                })
            });
            if (!res.ok) throw res;
            const json = await res.json();

            if (json.CODE === 1) {
                if (json.DATA && json.DATA.length > 0) {
                    updateState({
                        data: json.DATA[0] || {},
                        open: true
                    });
                }
            } else {
                alert(json.USER_MESSAGE + '\n' + json.SYSTEM_MESSAGE);
            }
            console.log(json);
        } catch (error) {
            if (error.status == 401) {
                updateState({
                    isLoginMenu: true,
                    isReload: false
                });
            } else {
                alert('Failed to fetch, Please try again later.');
                console.log(error);
            }
        }
        updateState({ loadingData: false });
    };

    const onSubmitClick = async () => {
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationSubmitApplication`;
        updateState({ loadingSubmit: true });

        try {
            const res = await fetch(url, {
                method: "Post",
                headers: new Headers({
                    Authorization: "Bearer " + localStorage.getItem("uclToken")
                })
            });
            if (!res.ok) throw res;
            const json = await res.json();

            if (json.CODE === 1) {
                localStorage.setItem("isSubmitted", 1);
                handleSuccessDialog();
            } else {
                alert(json.USER_MESSAGE + '\n' + json.SYSTEM_MESSAGE);
            }
            console.log(json);
        } catch (error) {
            if (error.status == 401) {
                updateState({
                    isLoginMenu: true,
                    isReload: false
                });
            } else {
                alert('Operation Failed , Please try again later.');
                console.log(error);
            }
        }
        updateState({ loadingSubmit: false });
    };

    const DownloadFile = (fileName) => {
        const data = new FormData();
        data.append("fileName", fileName); // Append unused? GET request doesn't use body. 
        // Original code appends data but does GET fetch(url). 
        // GET requests ignore body. The fileName is in URL query param. 
        // I will keep it as original but it is redundant.

        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME
            }/common/CommonViewFile?fileName=${encodeURIComponent(fileName)}`;

        fetch(url, {
            method: "GET",
            headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("uclToken"),
            }),
        })
            .then((res) => {
                if (res.status === 200) {
                    return res.blob();
                } else if (res.status == 401) {
                    updateState({
                        isLoginMenu: true,
                        isReload: false
                    });
                    return {};
                } else {
                    alert('Operation Failed, Please try again later.');
                    return {};
                }
            })
            .then((result) => {
                if (!(result instanceof Blob)) return;

                var csvURL = window.URL.createObjectURL(result);
                var tempLink = document.createElement("a");
                tempLink.href = csvURL;
                tempLink.setAttribute("download", fileName);
                tempLink.click();
                console.log(csvURL);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleClose = () => {
        updateState({
            open: false
        });
    };

    const handleSuccessDialog = () => {
        updateState({
            successDialog: !state.successDialog,
        });
    };

    const isSubmitted = localStorage.getItem("isSubmitted");

    return (
        <Fragment>
            <LoginMenu reload={state.isReload} open={state.isLoginMenu} handleClose={() => updateState({ isLoginMenu: false })} />
            <Dialog
                open={state.successDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Success"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Your <b>Admission Application</b> and <b>Documents</b> has been Submitted Successfully. Please click next to proceed to the payment of <b>Registration Fee</b>.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>

                    <Button color="primary" >
                        <Link style={{ textDecoration: 'none' }} to='/dashboard/registration-fee-payment'>
                            Next
                        </Link>
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={state.isNotUploaded}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Incomplete Documents"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {state.firstMsg}
                        <div> <strong>{state.uploadMsg}</strong> </div>

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="primary"
                        variant="outlined"
                        style={{
                            marginBottom: 10,
                            marginRight: 10,
                            minWidth: 150,
                            textTransform: "capitalize",
                            color: "#303F9F",
                            borderColor: "#303F9F",
                        }}
                        disabled={state.loadingData}
                    >
                        <Link
                            style={{ textDecoration: "none" }}
                            to="/dashboard/documents"
                        >
                            Go to Upload Documents
                        </Link>
                    </Button>
                </DialogActions>
            </Dialog>
            <DisplayAdmissionApplications documentData={state.documentsData} onDownload={fileName => DownloadFile(fileName)} data={state.data} open={state.open} handleClose={() => handleClose()} />
            <div style={{ padding: 20 }}>
                <Typography style={{ color: '#1d5f98', fontWeight: 600, fontSize: 20 }} variant="h5">
                    Review & Submit Admission Application
                </Typography>
                <Divider style={{
                    backgroundColor: 'rgb(58, 127, 187)',
                    opacity: '0.3'
                }} />
            </div>
            <div style={{
                fontSize: 20,
                marginLeft: 25,
                marginRight: 25,
                marginBottom: 20
            }}>
                Your Admission Application is almost complete. Please click <b>“Review Admission Application”</b>
                to review your application before submitting to look for any errors. Please click <b>“Edit Application”</b>
                to make any changes. Once the application is submitted, you will not be able to modify any information
                in your application. When you are ready to submit, please click <b>“Submit Admission Application”</b>.
            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginLeft: '-30px'
            }}>
                <Button disabled={state.loadingData || state.loadingCheck || state.loadingSubmit} onClick={() => getData()} color="primary" variant="contained" style={{
                    width: '300px', textTransform: 'capitalize', fontSize: 18, backgroundColor: '#174A84', marginBottom: 30, color: 'white',
                    marginTop: 30, marginRight: 25
                }}>
                    {(state.loadingData || state.loadingCheck) && <CircularProgress style={{ color: 'white', marginRight: 10 }} size={24} />} {(state.loadingData || state.loadingCheck) ? 'Please Wait...' : isSubmitted == 0 ? 'Review Admission Application' : 'View Admission Application'}
                </Button>
                {isSubmitted == 0 && (
                    <Button color="primary" variant="contained" style={{
                        width: '300px', textTransform: 'capitalize', fontSize: 18, backgroundColor: '#174A84', marginBottom: 30, color: 'white',
                        marginTop: 30, marginRight: 25
                    }}>
                        <Link style={{ textDecoration: 'none', textTransform: 'capitalize', fontSize: 18, backgroundColor: '#174A84', color: 'white' }} to='/dashboard/admission-application'>
                            Edit Admission Application
                        </Link>
                    </Button>


                )

                }
                {isSubmitted == 0 && (

                    <Button disabled={state.loadingSubmit} onClick={() => onSubmitClick()} color="primary" variant="contained" style={{ width: '300px', textTransform: 'capitalize', color: 'white', fontSize: 18, backgroundColor: '#174A84' }}>
                        {state.loadingSubmit && <CircularProgress style={{ color: 'white', marginRight: 10 }} size={24} />} {state.loadingSubmit ? 'Please Wait...' : 'Submit Admission Application'}
                    </Button>

                )

                }


            </div>
        </Fragment >
    );
};

export default ReviewAdmissionApplication;